import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Table,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
const RoleModal = forwardRef((props, ref) => {
  const { record: propRecord,onSuccess } = props;
  const [form] = Form.useForm();
  const [selectionType] = useState("checkbox");
  const [selectedUpdateRoleIds, setSelectedUpdateRoleIds] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [updateRoleListData, setUpdateRoleListData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal: async (record) => {
      try {
        setCurrentRecord(record);
        setVisible(true);
        await fetchRoleData(record.accountId); 
      } catch (error) {
        message.error("Failed to initialize modal");
      }
    },
  }));
  const fetchRoleData = async (accountId) => {
    try {
      setTableLoading(true);
      const response = await http.get(api.getAccountRoleList, {
        params: { accountId },
      });

      if (response.code === "1") {
        setUpdateRoleListData(response.data);
        const checkedIds = response.data
          .filter((item) => item.isChecked === 1)
          .map((item) => item.roleId);
        setSelectedRoleIds(checkedIds);
      }
    } finally {
      setTableLoading(false);
    }
  };

  const initOtherColumns = [
    {
      title: "Name",
      dataIndex: "roleName",
      key: "roleName",
      hidden: false,
      width: 300,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text) => text,
    },
  ];
  const [othercolumns, setOthercolumns] = useState(
    commonFn.handleColunmFn(initOtherColumns)
  );

  const rowSelection = {
    selectedRowKeys: selectedUpdateRoleIds,
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {},
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedUpdateRoleIds(selectedRowKeys);
      console.log("当前选中:", selectedRowKeys);
    },
  };
  const handleUpdateRoleSubmit = async () => {
    try {
      setTableLoading(true);
      console.log(currentRecord);
      const queryParams = {
        accountId: currentRecord.accountId,
        ids: selectedUpdateRoleIds,
      };
      const response = await http.post(
        `${api.getSaveOrUpdateAccountRole}`,
        queryParams
      );
      console.log("提交response:", response);
      if (response.code === "1") {
        message.success("Successfully.");
        setTableLoading(false);
       onSuccess?.();
        setVisible(false);
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTableLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            UPDATE ROLE
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={() => {
        setVisible(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
        loading={tableLoading} 
          onClick={handleUpdateRoleSubmit}
        >
          Submit
        </Button>,
      ]}
      styles={{
        body: {
          height: "80vh",
          padding: "16px 24px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
           loading={tableLoading} 
          columns={othercolumns.filter((col) => col.hidden === false)}
          dataSource={updateRoleListData}
          rowKey="roleId"
          scroll={{
            x: "max-content",
            y: "calc(80vh - 180px)",
          }}
          className="my-Table"
          style={{
            flex: 1,
            overflow: "auto",
          }}
        />
      </div>
    </Modal>
  );
});

export default RoleModal;
